import * as React from "react";

function SvgShowChart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path d="M0 0v34h34v-1H1V0H0z" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.99 2v30.986h7.997V2H23.99zm6.997 1H24.99v6.995h5.997V3zM14 33V6h8v27h-8zm1-26h6v12h-6V7zM3.998 32.986V13.994h7.997v18.992H3.998zm1-15.993h5.997v-1.999H4.998v1.999z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgShowChart;
